import { styled } from 'styled-components';

import { cssBreakpoints, h2Text, h3Text } from 'theme/theme';

export const CmsTileGridContentRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    margin-top: 58px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    flex: 0.5;
    padding-left: 60px;
    min-width: 50%;
    overflow: auto;
    max-height: 100%;
  }
`;

export const CmsTileModalHeading = styled.h2`
  ${h2Text};

  margin-top: 0;
  margin-bottom: 27px;
`;

export const CmsTileModalSubheading = styled.h3`
  ${h3Text};

  margin-top: 0;
  margin-bottom: 16px;
`;
